module.exports = __webpack_public_path__ + "img/bike-for-good.4bdeb09a.png";